export enum eTaxCertificationClassCodes {
  SingleFamily = 'SINGLE_FAMILY',
  MultiFamily = 'MULTI_FAMILY',
  Duplex = 'DUPLEX',
}

export const TaxCertificationClassCodesLabels = {
  [eTaxCertificationClassCodes.SingleFamily]: 'Single Family',
  [eTaxCertificationClassCodes.MultiFamily]: 'Multi Family',
  [eTaxCertificationClassCodes.Duplex]: 'Duplex',
};
